import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Button, Modal, Input, Flex, Form, Radio, Table, DatePicker, Space, Select, message } from "antd";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { CheckOutlined, CloseOutlined, SearchOutlined } from "@ant-design/icons"; // Importing icons
import Component from "../../../components";
import Spinner from "../../../components/Spinner/Spiner";
import { useStore } from "../../../root-store-context";
import "./SubmissionDetails.css";
import Swal from "sweetalert2";
import CommonFunctions from "../../../utils/CommonFunciton";
import TextInput from "../../../components/TextInput/TextInput";
import SelectBox from "../../../components/SelectBox/SelectBox";
import moment from "moment";
import dayjs from "dayjs";

const utc = require("dayjs/plugin/utc");

dayjs.extend(utc);
const startOfMonth = dayjs().startOf("month").utc().format("YYYY-MM-DDTHH:mm:ss");
const endOfMonth = dayjs().endOf("month").utc().format("YYYY-MM-DDTHH:mm:ss");
const defaultValue = {
  columnFilters:{},
  current: 1,
  pageSize: 10,
  filter: "",
  total: 0,
  sort: "DESC",
  column: "submissionDate",
  startDate: startOfMonth,
  endDate: endOfMonth,
}
const Submissions = () => {
  const debounceTimer = useRef(null);
  const isRestoringFromCacheRef = useRef(false);
  const { apiStore } = useStore();
  const { residentKey } = useParams();
  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const navigate = useNavigate();
  const location = useLocation();
  const { locationPagination, timeFilter, searchFilter } = location?.state ?? {};
  const [form] = Form.useForm()
  const [filterForm] = Form.useForm()
  const [paginations, setPagination] = useState(defaultValue);
  const [filterTerm, setFilterTerm] = useState(timeFilter || "thisMonth");
  const [searchTerm, setSearchTerm] = useState(``);
  const [showCustomDatePicker, setShowCustomDatePicker] = useState(false);
  const [customRange, setCustomRange] = useState([]);
  const [loading, setIsLoading] = useState(false);
  const [submissions, setSubmissions] = useState([]);
  const [currentRecord, setCurrentRecord] = useState({});
  const [isPaymentOptionModalOpen, setIsPaymentOptionModalOpen] = useState(false);
  const [isAchPayment, setIsAchPayment] = useState(false);
  const [payaResponse, setPayaResponse] = useState(null);
  const [paymentFormUrl, setPaymentFormUrl] = useState(null);
  const [isPaymentFormUnavailable, setIsPaymentFormUnavailable] = useState(false);

    const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
        <div style={{ padding: 8 }} onClick={(e) => e.stopPropagation()}>
            <Input
                placeholder={`Search ${dataIndex}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                    setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => {
                    applyColumnFilter(dataIndex, selectedKeys[0]);
                    close();
                }}
                style={{ marginBottom: 8, display: 'block' }}
            />
            <Button
                type="primary"
                onClick={() => {
                    applyColumnFilter(dataIndex, selectedKeys[0]);
                    close();
                }}
                size="small"
                style={{ width: 90, marginRight: 8 }}
            >
                Search
            </Button>
            <Button
                onClick={() => {
                    setSelectedKeys([]);
                    applyColumnFilter(dataIndex, null);
                    close();
                }}
                size="small"
                style={{ width: 90 }}
            >
                Reset
            </Button>
        </div>
    ),
    filterIcon: (filtered) => (
        <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M14 14L11.1 11.1M12.6667 7.33333C12.6667 10.2789 10.2789 12.6667 7.33333 12.6667C4.38781 12.6667 2 10.2789 2 7.33333C2 4.38781 4.38781 2 7.33333 2C10.2789 2 12.6667 4.38781 12.6667 7.33333Z"
                                            stroke="#757575"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
    ),
});

const getColumnSelectProps = (dataIndex, options) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
        <div style={{ padding: 8 }} onClick={(e) => e.stopPropagation()}>
            <Select
                placeholder={`Select ${dataIndex}`}
                value={selectedKeys[0]}
                style={{ width: 200, marginBottom: 8 }}
                allowClear
                onChange={(value) => {
                    setSelectedKeys(value ? [value] : []);
                }}
            >
                {options.map(opt => (
                    <Select.Option key={opt} value={opt}>
                        {opt}
                    </Select.Option>
                ))}
            </Select>

            <div style={{ display: "flex", gap: 8 }}>
                <Button
                    type="primary"
                    size="small"
                    onClick={() => {
                        applyColumnFilter(dataIndex, selectedKeys[0]);
                        close();
                    }}
                >
                    Apply
                </Button>

                <Button
                    size="small"
                    onClick={() => {
                        setSelectedKeys([]);
                        applyColumnFilter(dataIndex, null);
                        close();
                    }}
                >
                    Reset
                </Button>
            </div>
        </div>
    ),
    filterIcon: (filtered) => (
        <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M14 14L11.1 11.1M12.6667 7.33333C12.6667 10.2789 10.2789 12.6667 7.33333 12.6667C4.38781 12.6667 2 10.2789 2 7.33333C2 4.38781 4.38781 2 7.33333 2C10.2789 2 12.6667 4.38781 12.6667 7.33333Z"
                                            stroke="#757575"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
    ),
});

const applyColumnFilter = (column, value) => {
  setPagination(prev => {
    const updatedFilters = {
      ...prev.columnFilters,
      [column]: value,
    };

    if (!value) delete updatedFilters[column];

    const safePageSize = prev.pageSize && prev.pageSize > 0 ? prev.pageSize : 10;

    // Call API with updated filters
    GetAllSubmissions(
      updatedFilters,
      prev.column,
      prev.sort,
      1,
      safePageSize,
      prev.endDate,
      prev.startDate
    );

    return {
      ...prev,
      columnFilters: updatedFilters,
      current: 1,
      pageSize: safePageSize,
    };
  });
};



  const columns = [
    {
      title: "Request ID",
      dataIndex: "id",
      key: "id",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      filteredValue: paginations.columnFilters.id ? [paginations.columnFilters.id] : null,
      ...getColumnSearchProps("id"),
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <div className="tenant-action-wrap">
          <Button
            style={{
              borderRadius: 19,
              border: "1px solid #fff",
              color: "#fff",
              backgroundColor: "#5A7890",
              height: "2rem",
              width: "7rem",
            }}
            onClick={() => {
              // Saving current state AND data to localStorage before navigating
              const stateToSave = {
                pagination: paginations,
                filterTerm: filterTerm,
                searchTerm: searchTerm,
                submissions: submissions, // Save the current data
                showCustomDatePicker: showCustomDatePicker,
                customRange: customRange
              };
              localStorage.setItem('tenantRegistrationState', JSON.stringify(stateToSave));
              
              navigate(`/Forms/TenantRegistrations/View/${residentKey || ""}`, {
                state: { submissionId: record.id, pagination: paginations, filter: filterTerm, search: searchTerm },
              });
            }
            }
          >
            View Details
          </Button>
          {(record.paymentStatusName === "Pending" || record.paymentStatusName === "Fail") && record.amount > 0 && (
            <Button
              style={{
                backgroundColor: "#5A7890",
                color: "#fff",
              }}
              onClick={() => {
                setCurrentRecord(record);
                setIsPaymentOptionModalOpen(true);
              }}
            >
              Make a Payment
            </Button>
          )}
        </div>
      ),
    },
    {
      title: "Property Name",
      dataIndex: "propertyName",
      key: "propertyName",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      filteredValue: paginations.columnFilters.propertyName ? [paginations.columnFilters.propertyName] : null,
      ...getColumnSearchProps("propertyName"),
    },
    {
      title: "Submission Date",
      dataIndex: "submissionDate",
      key: "submissionDate",
      defaultSortOrder: "descend",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text) => CommonFunctions.formatUTCToLocal(text),
    },
    {
      title: "Approval",
      dataIndex: "requestStatusName",
      key: "requestStatusName",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      filteredValue: paginations.columnFilters.requestStatusName ? [paginations.columnFilters.requestStatusName] : null,
      ...getColumnSelectProps("requestStatusName", CommonFunctions.approvalOptions.map(option => option.label)),
    },
    {
      title: "Payment",
      dataIndex: "paymentStatusName",
      key: "paymentStatusName",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      filteredValue: paginations.columnFilters.paymentStatusName ? [paginations.columnFilters.paymentStatusName] : null,
      ...getColumnSelectProps("paymentStatusName", CommonFunctions.paymentStatuses.map(option => option.label)),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text) => (text ? `$${parseFloat(text).toFixed(2)}` : ``),
      filteredValue: paginations.columnFilters.amount ? [paginations.columnFilters.amount] : null,
      ...getColumnSearchProps("amount"),
    },
    {
      title: "Transaction Id",
      dataIndex: ["paymentDetails", "transactionId"],
      key: "transactionId",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      filteredValue: paginations.columnFilters.transactionId ? [paginations.columnFilters.transactionId] : null,
      ...getColumnSearchProps("transactionId"),
    },
    {
      title: "Property Address",
      dataIndex: "propertyAddress",
      key: "propertyAddress",
      sorter: true,
      render: (value, record) => `${record?.propertyFullAddress}, ${record?.propertyCity}, ${record?.propertyState}, ${record?.propertyZip}`,
      sortDirections: ['ascend', 'descend', 'ascend'],
      filteredValue: paginations.columnFilters.propertyAddress ? [paginations.columnFilters.propertyAddress] : null,
      ...getColumnSearchProps("propertyAddress"),
    },
    {
      title: "Submission Type",
      dataIndex: "submissionType",
      key: "submissionType",
      sorter: true,
      render: (value, record) => record?.userId != null ? "Home Owner" : "Non Home Owner",
      sortDirections: ['ascend', 'descend', 'ascend'],
    },
  ];
  const GetAllSubmissions = (columnFilters, sortColumn, sortOrder, pageNumber, pageSize, endDate, startDate) => {
    // Prevent API call if we're restoring from cache
    if (isRestoringFromCacheRef.current) {
      return;
    }

    let req = {
      residentKey: apiStore?.configApi?.community?.residentKey,
      columnFilters,
      sortColumn,
      sortOrder,
      pageNumber,
      pageSize,
      endDate,
      startDate
    }
    setIsLoading(true);
    apiStore.FormsApiClient.GetAllTenantSubmissions(req)
      .then((res) => {
        setSubmissions(res?.data?.data);
        setPagination(prev => ({
          ...prev,
          total: res?.data?.data?.totalCount,
        }));
      })
      .catch(() => { })
      .finally(() => {
        setIsLoading(false)
      });
  }

  const handleFilterSubmissions = (e) => {
    const value = e?.target?.value;
    const search = form?.getFieldValue('search');
    setShowCustomDatePicker(false);
    setCustomRange([]);
    let startDate, endDate;

    switch (value) {
      case "all":
                startDate = null;
                endDate = null;
                break;

      case "thisMonth":
        startDate = startOfMonth;
        endDate = endOfMonth;
        break;

      case "lastMonth":
        startDate = dayjs().subtract(1, "month").startOf("month").utc().format("YYYY-MM-DDTHH:mm:ss");
        endDate = dayjs().subtract(1, "month").endOf("month").utc().format("YYYY-MM-DDTHH:mm:ss");
        break;

      case "customRange":
        setShowCustomDatePicker(true);
        return;
    }
    const safePageSize =
        paginations.pageSize && paginations.pageSize > 0
            ? paginations.pageSize
            : 10;
    setFilterTerm(value);
      GetAllSubmissions(
          paginations.columnFilters,
          paginations.column,
          paginations.sort,
          1,
          safePageSize,
          endDate,
          startDate,
      );
      paginations.startDate = startDate;
      paginations.endDate = endDate;
      setPagination((prev) => ({
          ...prev,
          current: 1, // reset pagination state
          pageSize: safePageSize,
          startDate,
          endDate,
      }));
  };

  const handleApplyCustomRange = () => {
    if (customRange.length === 2) {
      const start = customRange[0].utc().format("YYYY-MM-DDTHH:mm:ss");
      const end = customRange[1].utc().format("YYYY-MM-DDTHH:mm:ss");

      const safePageSize =
          paginations.pageSize && paginations.pageSize > 0
              ? paginations.pageSize
              : 10;

      paginations.startDate = start;
      paginations.endDate = end;
      GetAllSubmissions(
          paginations.columnFilters,
          paginations.column,
          paginations.sort,
          1, // ✅ reset
          safePageSize,
          end,
          start,
      );
      setPagination((prev) => ({
          ...prev,
          current: 1,
          pageSize: safePageSize,
          startDate: start,
          endDate: end,
      }));
    } else {
      message.error({ content: "Please select both start and end dates." });
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
        const sortOrder = sorter.order === "ascend" ? "asc" : sorter.order === "descend" ? "desc" : null;
        let sortField;
        if (Array.isArray(sorter.field)) {
            sortField = sorter.field[sorter.field.length - 1]; // => 'transactionId'
        } else {
            sortField = sorter.field;
        }
        const currentPage =
            pagination?.current && pagination.current > 0
                ? pagination.current
                : 1;
        const sortColumn = sortOrder ? sortField : null;
        const safePageSize = pagination?.pageSize && pagination.pageSize > 0 ? pagination.pageSize : 10;

        setPagination({
            ...paginations,
            sort: sortOrder,
            column: sortColumn,
            current: currentPage,
            pageSize: safePageSize,
        });
        GetAllSubmissions(
            paginations.columnFilters,
            sortColumn,
            sortOrder,
            currentPage,
            safePageSize,
            paginations.endDate,
            paginations.startDate,
        );
    };

  const handleRadioChange = (e) => {
    setIsAchPayment(e.target.value === "ACH");
  };
  const handlePaymentOptionModalCancel = () => {
    setIsPaymentOptionModalOpen(false);
  };
  const handleReload = () => {
    navigate(location.pathname, { replace: true });
  };
  const handleCreateRegistration = () => {
    const residentKey = apiStore?.configApi?.community?.residentKey;
    navigate(`/Forms/TenantRegistrations/Create`);
  };

 
  useEffect(() => {
    setPaymentFormUrl(null);
    setIsPaymentFormUnavailable(false);
    if (!isPaymentOptionModalOpen || !currentRecord?.id) return undefined;

    let isCurrent = true;
    apiStore.FormsApiClient.GetTenantPaymentFormUrl(currentRecord.id, isAchPayment ? "ach" : "cc")
      .then((url) => {
        if (!isCurrent) return;
        setPaymentFormUrl(url);
        setIsPaymentFormUnavailable(!url);
      })
      .catch(() => {
        if (isCurrent) setIsPaymentFormUnavailable(true);
      });
    return () => {
      isCurrent = false;
    };
  }, [apiStore, isPaymentOptionModalOpen, isAchPayment, currentRecord]);

  useEffect(() => {
    if (!paymentFormUrl) return undefined;
    // Only the Paya form opened above may report a payment.
    const allowed = new URL(paymentFormUrl).origin;
    const receiveMessage = (event) => {
      if (event.origin !== allowed) return;
      setIsPaymentOptionModalOpen(false);
      setIsLoading(true);
      setPayaResponse(JSON.parse(event.data));
    };
    window.addEventListener("message", receiveMessage, false);
    return () => window.removeEventListener("message", receiveMessage, false);
  }, [paymentFormUrl]);

  useEffect(() => {
    if (payaResponse) {
      const statusMessage = CommonFunctions.getStatusMessage(payaResponse?.status_id);
      const reasonCodeMessage = CommonFunctions.getReasonCodeMessage(payaResponse?.reason_code_id);

      apiStore.FormsApiClient.ProcessTenantPayment(payaResponse)
        .then((res) => {
          if (res?.data?.status) {
            navigate(`/Forms/TenantRegistrations/`)
            GetAllSubmissions(paginations?.columnFilters, paginations?.column, paginations?.sort, paginations?.current, paginations?.pageSize, paginations?.endDate, paginations?.startDate)
            if (reasonCodeMessage) {
              Swal.fire({
                title: `${statusMessage}`,
                text: `Reason: ${reasonCodeMessage}`,
                icon: "error",
                confirmButtonColor: "#5A7890",
              });
            }
            else {
              Swal.fire({
                title: isAchPayment ? 'ACH - Accepted' : 'CC - Approved',
                text: isAchPayment ? `${statusMessage}` : `Payment Done Successfully.`,
                icon: "success",
                confirmButtonColor: "#5A7890",
              });
            }
          }
          else {
            Swal.fire({
              text: "Something went wrong at the moment",
              icon: "error",
              confirmButtonColor: "#5A7890",
            });
          }
        })
        .catch(() => { }).finally(() => { setIsLoading(false); })
    }
  }, [apiStore, payaResponse]);


  useEffect(() => {
    // Clearing localStorage on page refresh
    const handleBeforeUnload = () => {
      localStorage.removeItem('tenantRegistrationState');
    };
    
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("beforeunload", handleReload);
    
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("beforeunload", handleReload);
    };
  }, []);
  
  useEffect(() => {
   // Checking localStorage for persisted state first
    const savedState = localStorage.getItem('tenantRegistrationState');
    if (savedState) {
      try {
        const parsedState = JSON.parse(savedState);
        
        // Set ref flag IMMEDIATELY to block any API calls
        isRestoringFromCacheRef.current = true;
        
        // Restore all state values including the data
        setSubmissions(parsedState.submissions); // Restore the saved data FIRST
        setPagination(parsedState.pagination);
        setFilterTerm(parsedState.filterTerm);
        setSearchTerm(parsedState.searchTerm);
        setShowCustomDatePicker(parsedState.showCustomDatePicker || false);
        setCustomRange(parsedState.customRange || []);
        
        // Set form values
        filterForm.setFieldsValue({ filterBy: parsedState.filterTerm });
        form.setFieldsValue({ search: parsedState.searchTerm });
        
        // NO API CALL - we're using the saved data
        
        // Clear localStorage after restoring
        localStorage.removeItem('tenantRegistrationState');
        
        // Reset the ref flag after a delay to allow normal operations
        setTimeout(() => {
          isRestoringFromCacheRef.current = false;
        }, 500);
      } catch (error) {
        localStorage.removeItem('tenantRegistrationState');
        isRestoringFromCacheRef.current = false;
        // If restore fails, make API call with default values
        GetAllSubmissions(
          '',
          paginations?.column,
          paginations?.sort,
          paginations?.current,
          paginations?.pageSize,
          paginations?.endDate,
          paginations?.startDate
        );
      }
    } else if (locationPagination && Object.keys(locationPagination)?.length > 0) {
      // Fallback to navigation state if no localStorage
      setPagination(locationPagination);
      
      if (timeFilter) {
        setFilterTerm(timeFilter);
        setTimeout(() => {
          filterForm.setFieldsValue({ filterBy: timeFilter });
        }, 0);
      }
      
      if (searchFilter) {
        setSearchTerm(searchFilter);
        setTimeout(() => {
          form.setFieldsValue({ search: searchFilter });
        }, 0);
      }
      
      GetAllSubmissions(
        locationPagination?.columnFilters,
        locationPagination?.column,
        locationPagination?.sort,
        locationPagination?.current,
        locationPagination?.pageSize,
        locationPagination?.endDate,
        locationPagination?.startDate
      );
    } else {
      // Fresh load - use default values
      GetAllSubmissions(
        paginations?.columnFilters,
        paginations?.column,
        paginations?.sort,
        paginations?.current,
        paginations?.pageSize,
        paginations?.endDate,
        paginations?.startDate
      );
    }
  }, []);

  useEffect(() => {
    // Skip this effect if we're restoring from cache
    if (isRestoringFromCacheRef.current) {
      return;
    }
    
    if (submissions) {
      setIsLoading(false);
    }
    if (submissions?.totalCount > 0) {
      if (locationPagination && Object.keys(locationPagination)?.length > 0) {
        setPagination(locationPagination);
      } else {
        setPagination({
          ...paginations,
          total: submissions?.totalCount,
        });
      }
    }
  }, [submissions]);

  return (
      <>
          {loading && <Spinner />}
          <Row justify={'center'}>
              <Col sm={20} className="text-center">
                  <Flex
                      justify="space-between"
                      wrap="wrap"
                      align="center"
                      gap="16px"
                      style={{ paddingBottom: 24 }}
                  >
                      <Flex
                          wrap="wrap"
                          align="center"
                          gap="16px"
                          className="w-mo-100"
                      >
                          <h1 className="page-title">Tenant Registration</h1>
                      </Flex>
                      <Flex
                          wrap="wrap"
                          align="center"
                          gap="16px"
                          className="w-mo-100"
                      >
                          <Button
                              type="primary"
                              onClick={handleCreateRegistration}
                          >
                              New Registration
                          </Button>
                      </Flex>
                  </Flex>
              </Col>
              <Col sm={20} className="text-center">
                  <div className="d-flex justify-content-between page-header-wrap">
                      <div className="header-filter-wrapper filterContainer">
                          <div className="header-filter-wrap filter-date-container">
                              <Form
                                  form={filterForm}
                                  className="filterSubmission"
                                  initialValues={{ filterBy: filterTerm }}
                              >
                                  <SelectBox
                                      label=""
                                      name="filterBy"
                                      placeholder="Filter By"
                                      size="large"
                                      showSearch
                                      options={CommonFunctions.filterOptions}
                                      onChange={handleFilterSubmissions}
                                  />
                              </Form>
                              {showCustomDatePicker && (
                                  <div
                                      direction="vertical"
                                      className="datepicker-container"
                                  >
                                      <RangePicker
                                          showTime
                                          format="YYYY-MM-DD HH:mm:ss"
                                          onChange={(values) =>
                                              setCustomRange(values)
                                          }
                                          value={customRange}
                                      />
                                      <Button
                                          type="primary"
                                          className="apply-btn"
                                          onClick={handleApplyCustomRange}
                                      >
                                          Submit
                                      </Button>
                                  </div>
                              )}
                          </div>
                      </div>
                  </div>

                  <Table
                      columns={columns}
                      scroll={{ x: 'max-content' }}
                      dataSource={submissions?.tenantRegistrations ?? []}
                      onChange={handleTableChange}
                      pagination={{
                          current: paginations.current,
                          pageSize: paginations.pageSize,
                          total: paginations.total,
                          showSizeChanger: true,
                      }}
                  />
              </Col>
          </Row>
          <Modal
              title={`Payment Option`}
              visible={isPaymentOptionModalOpen}
              onOk={() => {}}
              onCancel={handlePaymentOptionModalCancel}
              width={400}
              footer={false}
          >
              <Form>
                  <Radio.Group
                      name="paymentMethod"
                      value={isAchPayment ? 'ACH' : 'CC'}
                      onChange={handleRadioChange}
                  >
                      <Radio value="CC">Pay with Credit Card</Radio>
                      <Radio value="ACH">Pay with eCheck/ACH</Radio>
                  </Radio.Group>
                  {isAchPayment && (
                      <>
                          <p>
                              By authorizing this transaction, customer agrees
                              that merchant may convert this transaction into an
                              Electronic Funds Transfer (EFT) transaction or
                              paper draft, and to debit this account for the
                              amount of the transaction. Additionally, in the
                              event this draft or EFT is returned unpaid, a
                              service fee, as allowable by law, will be charged
                              to this account via EFT or draft. In the event you
                              choose to revoke this authorization, please do so
                              by contacting the merchant directly. Please note
                              that processing times may not allow for revocation
                              of this authorization.
                          </p>
                      </>
                  )}
                  {paymentFormUrl && (
                      <div className={`${!isAchPayment ? "first-frame" : "iframe"}`}>
                          <iframe src={paymentFormUrl} title="Example iframe"></iframe>
                      </div>
                  )}
                  {isPaymentFormUnavailable && (
                      <p>Online payment is not available right now. Please try again later.</p>
                  )}
              </Form>
          </Modal>
      </>
  );

};

export default Submissions;
